export const ActionsTypes = {
	DUPLICATE_CHECKLISTS: "DUPLICATE_CHECKLISTS",
	TRANSFER_CHECKLISTS: "TRANSFER_CHECKLISTS",
	LINK_WEEZ_TAG_TO_CHECKLISTS: "LINK_WEEZ_TAG_TO_CHECKLISTS"
};

export const ActionTypeToDataMapping = {
	DUPLICATE_CHECKLISTS: "link_period_to_checkpoints",
	TRANSFER_CHECKLISTS: "link_period_to_checkpoints",
	LINK_WEEZ_TAG_TO_CHECKLISTS: "checkpoint_weeztag"
};
